module.exports = __webpack_public_path__ + "static/media/matching-score-rank-6.c1c0a891.png";